import React from 'react';
import LeftContent from './LeftContent';
import { Outlet } from 'react-router-dom';

const VendorMainContent = () => {
  return (
    <div className="row g-0 align-items-center min-vh-100 p-lg-0 p-4" style={{ backgroundColor: 'hsl(0, 0%, 96%)' }}>
      <div className="col-md-12">
        <div className="container">
          <div className="row g-5 align-items-start">
            <LeftContent /> {/* Left content stays constant */}
            <div className="col-md-6 vh-100 overflow-scroll align-content-center">
              <div className="card my-4">
                <div className="card-body py-5 px-md-5">
                  {/* This is where nested routes will render */}
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorMainContent;
